import { useQuery } from 'react-query';
import { getBanner, getShortcut } from 'apis';
import { TBannerType, TWebBannerType } from 'interfaces/popupBanner';

export const useBanner = () => {
  return useQuery<TWebBannerType>(['getBanner'], () => getBanner());
};

export const useShortcut = () => {
  return useQuery<TBannerType>(['getShortcut'], () => getShortcut());
};
